import ContactSales from "./sections/contact-sales";
import { CustomWorkFlow } from "./sections/custom-work-flow";
import { Dashboard } from "./sections/dashboard";
import { Hero } from "./sections/hero";
import { PreRentalVerification } from "./sections/pre-rental-verification";
import Pricing from "./sections/pricing";
import { VerificationFeatures } from "./sections/verification-features";
import { CaseStudy } from "./sections/case-study";

export default function RentidPC() {
  return (
    <div style={{ minHeight: "100vh" }}>
      <Hero />
      <PreRentalVerification />
      <CustomWorkFlow />
      <VerificationFeatures />
      <Dashboard />
      <CaseStudy />
      <Pricing />
      <ContactSales />
    </div>
  );
}
